import useCrudFilters, {
  CrudFilters,
} from "../../../../../hooks/useCrudFilters";
import { Button, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { EntitySelectField } from "../../../../general/fields/modules/commons/entitySelectField/entitySelectField";
import { warehouseSchema } from "../../../warehouse/domain/schemas/warehouseSchema";
import { useState } from "react";
import { TableFiltersWrapper } from "../../../../general/table/modules/commons/tableFilters/tableFilters";
import { TableFilters } from "../../../../general/table/modules/commons/tableFilters/tableFilters";
import { TableFilterInputWrapper } from "../../../../general/table/modules/commons/tableFilters/tableFilters";
import { shelvingUnitSchema } from "../../../shelvingUnit/domain/schemas/shelvingUnitSchema";

export const PositionTableFilters = ({
  updateFilter,
  removeFilter,
  getFilter,
  filters,
  resetFilters,
}: CrudFilters) => {
  const searchValue = getFilter("label") as string;
  const warehouseValue = getFilter("shelvingUnit.path.warehouse.id");
  const shelveValue = getFilter("shelvingUnit.id");
  const statusValue = getFilter("shelvingUnit.path.warehouse.status");
  const { t } = useTranslation("common");

  const shelveFilters = useCrudFilters({
    searchBy: "SearchByRootShelvingUnit",
    fields: {},
  });

  const [firstLoad, setFirstLoad] = useState(true);

  return (
    <TableFiltersWrapper>
      <TableFilters>
        <TableFilterInputWrapper md={3}>
          <label className="d-flex justify-content-between">
            {t("Search")}
            <span>x</span>
          </label>
          <Form.Control
            type="text"
            placeholder={t("Search by name")}
            value={searchValue ?? ""}
            onChange={(event) => {
              const value = event.target.value;
              if (value === "") {
                removeFilter("label");
              } else {
                updateFilter("label", value);
              }
            }}
          />
        </TableFilterInputWrapper>

        <TableFilterInputWrapper md={3}>
          <label>{t("Warehouse")}</label>
          <EntitySelectField
            entity={"Warehouse"}
            prefix={"warehouses"}
            onChange={(option) => {
              if (firstLoad) {
                setFirstLoad(false);
                return;
              }
              if (option == null) {
                removeFilter("shelvingUnit.path.warehouse.id");
                removeFilter("shelvingUnit.path.id");
                shelveFilters.removeFilter("path.warehouse.id");
                return;
              }

              const { value } = option as { value: string };
              removeFilter("shelvingUnit.path.id");
              updateFilter("shelvingUnit.path.warehouse.id", value);
              shelveFilters.updateFilter("path.warehouse.id", value);
            }}
            limit={100}
            clearable={true}
            schema={warehouseSchema}
            value={warehouseValue}
          />
        </TableFilterInputWrapper>

        <TableFilterInputWrapper md={3}>
          <label>{t("Shelving unit")}</label>
          <EntitySelectField
            entity={"ShelvingUnit"}
            prefix={"shelvingUnits"}
            onChange={(option) => {
              if (option == null) {
                removeFilter("shelvingUnit.id");
                return;
              }
              const { value } = option as { value: string };
              updateFilter("shelvingUnit.id", value);
            }}
            limit={100}
            clearable={true}
            schema={shelvingUnitSchema}
            filters={shelveFilters.filters}
            value={shelveValue}
            labelPrefix={"identifier"}
          />
        </TableFilterInputWrapper>

        <TableFilterInputWrapper md={3}>
          <label>{t("Status")}</label>
          <Form.Select
            onChange={(event) => {
              const value = event.target.value;
              if (value === "") {
                removeFilter("shelvingUnit.path.warehouse.status");
              } else {
                updateFilter(
                  "shelvingUnit.path.warehouse.status",
                  value === "1",
                );
              }
            }}
            value={`${statusValue ?? ""}`}
          >
            <option value={""}>{"- " + t("All") + " -"}</option>
            <option value={0}>{t("Inactive")}</option>
            <option value={1}>{t("Active")}</option>
          </Form.Select>
        </TableFilterInputWrapper>
      </TableFilters>
      {filters?.fields && Object.keys(filters.fields).length > 0 && (
        <Button
          onClick={resetFilters}
          size={"sm"}
          className="reset-filters"
          variant="light"
        >
          {t("Reset filters")}
        </Button>
      )}
    </TableFiltersWrapper>
  );
};
